import { environnement } from "configs/environnement";
import api from "./api";
import {
  IEventTypeResponse,
  ISaveEventType,
  IUpdateEventType,
} from "models/church.types";

const BASE_URL = `${environnement.baseURL}/event-types`;

export const EventTypeService = {
  /**
   * Récupérer la liste complète des types d'événements (paginée)
   * Utilise la route de recherche sans query pour tout récupérer
   */
  getAll: async (page: number, size: number) => {
    const response = await api.get<IEventTypeResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * La liste complète sans pagination
   * Utile pour les Select dans les formulaires d'événements
   */
  getAllSimple: async (): Promise<IEventTypeResponse[]> => {
    const response = await api.get<IEventTypeResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          page: 0,
          size: 1000,
          sort: "name,asc",
        },
      },
    );
    return response.data;
  },

  /**
   * Créer un nouveau type d'événement
   */
  create: async (eventType: ISaveEventType): Promise<IEventTypeResponse> => {
    const response = await api.post<IEventTypeResponse>(
      `${BASE_URL}`,
      eventType,
    );
    return response.data;
  },

  /**
   * Mettre à jour un type d'événement existant
   */
  update: async (eventType: IUpdateEventType): Promise<IEventTypeResponse> => {
    const response = await api.put<IEventTypeResponse>(
      `${BASE_URL}`,
      eventType,
    );
    return response.data;
  },

  /**
   * Récupérer un type d'événement par son ID
   */
  getById: async (id: number): Promise<IEventTypeResponse> => {
    const response = await api.get<IEventTypeResponse>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * Supprimer un type d'événement
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * Rechercher des types d'événements par mot-clé
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IEventTypeResponse[]>(
      `${BASE_URL}/_search`,
      {
        params: {
          query: query,
          page: page,
          size: size,
          sort: "id,desc",
        },
      },
    );
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
